module.exports = __webpack_public_path__ + "assets/media/5.5577d414.wav";